import { Neo4jConfig } from "~/utils";

const uri = "neo4j+s://b1aeddbd.databases.neo4j.io";
const user = "neo4j";
const password = "O50iA2MM0fPAOSTEZaH1j_rzNOad_O_Be8AN0Hww8WQ";

export const neo4jConfig: Neo4jConfig = {
  password,
  uri,
  user,
};
